import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
// The three faces, bundled into the build. Only the weights the
// stylesheet asks for: each is a file a tablet downloads on a connection
// that is the one thing here nobody can rely on.
import "@fontsource/barlow/400.css";
import "@fontsource/barlow/500.css";
import "@fontsource/barlow/600.css";
import "@fontsource/barlow/700.css";
import "@fontsource/barlow-condensed/600.css";
import "@fontsource/barlow-condensed/700.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/700.css";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Registered for installability. The employee itself forwards everything
// to the network — see public/sw.js.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {
      // Not being installable is not a reason to fail on the floor.
    });
  });
}
